import { Component, ViewEncapsulation } from '@angular/core';
import { Article } from '../../models/articles/articles.model';
import { CommunicationService } from '../../shared/services/communication.service';

import { ApiService } from '../../shared/services/api.service';
import { ListBase } from '../../shared/components/base/list/list.base.component';

@Component({
  selector: 'swb-article-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ArticleListComponent extends ListBase<Article> {

  public url = 'articles';
  public routePrefix = 'articles';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }

}
